'use client';

import { useState, useRef } from 'react';
import { openConfirmModal } from '@mantine/modals';
import { toast } from 'react-toastify';
import ReCAPTCHA from 'react-google-recaptcha';

import { Button } from '@/elements/button/button.component';
import { FormControl, Input, Label } from '@/styles/global.elements';
import { Container, Inputs, FormRow } from './newsletter-form.elements';

import { checkEmail, checkAlpha } from '@/utils/form-validation.utils';
import { handleErrors } from '@/helpers/handle-errors.helper';

const NewsletterForm = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    newsletterEmails: true,
  });
  const [status, setStatus] = useState(null);
  const reRef = useRef();

  const submitNewsletter = async () => {
    setStatus('sending');

    try {
      /* Google reCAPTCHA */
      const token = await reRef.current.executeAsync();

      const response = await fetch('/api/v1/brevo', {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...formData,
          sendCoupon: true,
          token,
        }),
      });

      const data = await response.json();

      if (data.success) {
        setStatus('success');
        toast.success('Hvala ti na prijavi na newsletter!');
      } else {
        setStatus('error');
        toast.error('Došlo je do greške kod prijave. Molimo pokušaj ponovno.');
        setTimeout(() => setStatus(null), 3000);
      }
    } catch (error) {
      handleErrors(error, { component: 'newsletter-form', action: 'submit newsletter' });
      setTimeout(() => setStatus(null), 3000);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    openConfirmModal({
      title: 'Molimo potvrdite slanje poruke.',
      labels: { confirm: 'Potvrdi', cancel: 'Odustani' },
      onConfirm: submitNewsletter,
    });
  };

  const emailValidation = (target) => {
    if (target.length > 0 && !checkEmail(target)) return 'invalid';
    else if (checkEmail(target)) return 'valid';
    return null;
  };

  const alphaValidation = (target) => {
    if (target.length > 0 && !checkAlpha(target)) return 'invalid';
    else if (target.length > 0 && checkAlpha(target)) return 'valid';
    return null;
  };

  const enableSubmit =
    formData.firstName.length > 0 &&
    formData.lastName.length > 0 &&
    checkAlpha(formData.firstName) &&
    checkAlpha(formData.lastName) &&
    checkEmail(formData.email) &&
    !status;

  return (
    <>
      <Container onSubmit={handleSubmit}>
        <Inputs>
          <FormRow>
            <FormControl>
              <Label>Ime:</Label>
              <Input
                type="text"
                value={formData.firstName}
                onChange={(e) => setFormData((prev) => ({ ...prev, firstName: e.target.value }))}
                placeholder="Upiši ime"
                $status={alphaValidation(formData.firstName)}
                $dark
              />
            </FormControl>
            <FormControl>
              <Label>Prezime:</Label>
              <Input
                type="text"
                value={formData.lastName}
                onChange={(e) => setFormData((prev) => ({ ...prev, lastName: e.target.value }))}
                placeholder="Upiši prezime"
                $status={alphaValidation(formData.lastName)}
                $dark
              />
            </FormControl>
          </FormRow>
          <FormControl>
            <Label>Email:</Label>
            <Input
              type="email"
              value={formData.email}
              onChange={(e) => setFormData((prev) => ({ ...prev, email: e.target.value }))}
              placeholder="Upiši email adresu"
              $status={emailValidation(formData.email)}
              $dark
            />
          </FormControl>
        </Inputs>
        <Button disabled={!enableSubmit} width="auto" background="light">
          Prijavi se
        </Button>
      </Container>
      <ReCAPTCHA
        sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
        size="invisible"
        ref={reRef}
      />
    </>
  );
};
export { NewsletterForm };
